import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';
import {TrelloCard} from '../../../trello-misc/data/trello-card';
import {Customer} from '../../../customer/data/customer';
import {ProjectFile} from './project-file';
import {ProjectComment} from './project-comment';
import {ProjectStatus} from './statuses/project-status';
import {ProjectParticipant} from './project-participant';
import {User} from 'projects/core/src/lib/login/data/user';
import {FinishingVendor} from '../../../vendor/data/finish-vendor';
import {ContactInfo} from '../../../customer/data/contactInfo';
import {Cart} from 'projects/cart-tv/src/app/data/cart';
import {ProjectActivity} from './activity/project-activity';

@JsonObject('model.project.Project')
export class Project extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'number')
  number?: string;

  @JsonProperty(String, 'name')
  name?: string;

  @JsonProperty(ProjectStatus, 'autoSelectedJobComplexity')
  autoSelectedJobComplexity?: ProjectStatus;

  @JsonProperty(String, 'location')
  location?: string;

  @JsonProperty(TrelloCard, 'card')
  card?: TrelloCard;

  @JsonProperty([Cart], 'carts')
  carts?: Cart[];

  @JsonProperty(Number, 'cardListId')
  cardListId?: number;

  @JsonProperty(Boolean, 'complexityChangedManually')
  complexityChangedManually?: boolean;

  @JsonProperty(Number, 'overallComplexity')
  overallComplexity?: number;

  @JsonProperty(String, 'cardListName')
  cardListName?: string;

  @JsonProperty([ProjectParticipant], 'participants')
  participants?: ProjectParticipant[];

  @JsonProperty(User, 'projectManager')
  projectManager?: User;

  @JsonProperty(Number, 'activeAlertsCount')
  activeAlertsCount?: number;

  @JsonProperty(Number, 'incompletePunchItemsCount')
  incompletePunchItemsCount?: number;

  @JsonProperty(Number, 'unreadNotificationCnt')
  unreadNotificationCnt?: number;

  @JsonProperty([ProjectFile], 'files')
  files?: ProjectFile[];

  @JsonProperty(ProjectStatus, 'status')
  status?: ProjectStatus;

  @JsonProperty(ProjectStatus, 'paymentStatus')
  paymentStatus?: ProjectStatus;

  @JsonProperty(ProjectStatus, 'docuSignStatus')
  docuSignStatus?: ProjectStatus;

  @JsonProperty(ProjectStatus, 'installationPaymentStatus')
  installationPaymentStatus?: ProjectStatus;

  @JsonProperty(Boolean, 'drawingApproved')
  drawingApproved?: boolean;

  @JsonProperty(ProjectStatus, 'type')
  type?: ProjectStatus;

  @JsonProperty([ProjectComment], 'comments')
  comments?: ProjectComment[] = []

  dueDate?: Date;

  @JsonProperty(DateConverter, 'clientPickupDate')
  clientPickupDate?: Date;

  @JsonProperty(DateConverter, 'machiningDate')
  machiningDate?: Date;

  @JsonProperty(DateConverter, 'finishDate')
  finishDate?: Date;

  @JsonProperty(ProjectStatus, 'jobComplexity')
  jobComplexity?: ProjectStatus;

  @JsonProperty(Customer, 'customer')
  customer?: Customer;

  @JsonProperty(DateConverter, 'orderFrontsDate')
  orderFrontsDate?: Date;

  @JsonProperty(DateConverter, 'finishingMachiningDate')
  finishingMachiningDate?: Date;

  @JsonProperty(FinishingVendor, 'finishingVendor')
  finishingVendor?: FinishingVendor;

  @JsonProperty(DateConverter, 'finishingSubmitDate')
  finishingSubmitDate?: Date;

  @JsonProperty(DateConverter, 'finishingPickupDate')
  finishingPickupDate?: Date;

  @JsonProperty(DateConverter, 'assemblyDate')
  assemblyDate?: Date;

  @JsonProperty(DateConverter, 'qualityControlDate')
  qualityControlDate?: Date;

  @JsonProperty(DateConverter, 'jobDeliveryDate')
  jobDeliveryDate?: Date;

  @JsonProperty(DateConverter, 'punchListDueDate')
  punchListDueDate?: Date;

  @JsonProperty(Boolean, 'clientPickupReady')
  clientPickupReady? = false;

  @JsonProperty(Boolean, 'machiningReady')
  machiningReady? = false;

  @JsonProperty(Boolean, 'orderFrontsReady')
  orderFrontsReady? = false;

  @JsonProperty(Boolean, 'finishingMachiningReady')
  finishingMachiningReady? = false;

  @JsonProperty(Boolean, 'finishingPickupReady')
  finishingPickupReady? = false;

  @JsonProperty(Boolean, 'finishingSubmitReady')
  finishingSubmitReady? = false;

  @JsonProperty(Boolean, 'assemblyReady')
  assemblyReady? = false;

  @JsonProperty(Boolean, 'qualityControlReady')
  qualityControlReady? = false;

  @JsonProperty(Boolean, 'jobDeliveryReady')
  jobDeliveryReady? = false;

  @JsonProperty(Boolean, 'hasPunchList')
  hasPunchList? = false;

  @JsonProperty(Boolean, 'hasCvFile')
  hasCvFile?: boolean;

  @JsonProperty(DateConverter, 'lastCvSync')
  lastCvSync?: Date;

  @JsonProperty(Boolean, 'inShopPunchList')
  inShopPunchList? = false;

  @JsonProperty(Boolean, 'punchListReady ')
  punchListReady? = false;

  @JsonProperty(DateConverter, 'proposed')
  proposed?: Date;

  @JsonProperty(Number, 'cabinetsTotal')
  cabinetsTotal?: number;

  @JsonProperty(Number, 'assemblyCabinetsDone')
  assemblyCabinetsDone?: number;

  @JsonProperty(Number, 'qualityControlCabinetsDone')
  qualityControlCabinetsDone?: number;

  @JsonProperty(Number, 'jobDeliveryCabinetsDone')
  jobDeliveryCabinetsDone?: number;

  @JsonProperty([ContactInfo], 'notificationContacts')
  notificationContacts?: ContactInfo[];

  @JsonProperty(String, 'migratedFromNumber')
  migratedFromNumber?: string;

  @JsonProperty(String, 'migratedToNumber')
  migratedToNumber?: string;

  @JsonProperty(DateConverter, 'migratedDate')
  migratedDate?: Date;

  @JsonProperty(User, 'migratedBy')
  migratedBy?: User;

  @JsonProperty(Boolean, 'salesListReady')
  salesListReady?: boolean;

  activities?: ProjectActivity[]

}
